import { FEED_VARIANTS, FEED_VARIANT_COOKIE, isFeedVariant } from './feedParams';

/**
 * The visitor's feed variant (P25028-237), read in the browser.
 *
 * The server sets the `feedVariant` cookie before it renders the first page, so the
 * browser normally only reads it. When it is missing (the local dev server renders
 * nothing on the server, or the cookie was cleared mid-visit), one is picked here and
 * saved the same way: a session cookie, so the order stays the same for the whole visit.
 */
export const browserFeedVariant = () => {
  if (typeof document === 'undefined') {
    return null;
  }
  const match = document.cookie
    .split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(`${FEED_VARIANT_COOKIE}=`));
  const saved = match ? match.slice(FEED_VARIANT_COOKIE.length + 1) : null;
  if (isFeedVariant(saved)) {
    return saved;
  }
  const picked = FEED_VARIANTS[Math.floor(Math.random() * FEED_VARIANTS.length)];
  document.cookie = `${FEED_VARIANT_COOKIE}=${picked}; path=/; SameSite=Lax`;
  return picked;
};
